//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
//CONTEXT
import { useCreativeState, useCreativeDispatch } from "../../../../contexts/creative.context";

export function CountdownIconPosition() {
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();

  return <>
    <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={4} />
    <div className="relative">
      <ComponentLibrary.PCRadioButtons
        label={"Countdown icon position"}
        checked={creative.metadata.icons.countdownIconPosition}
        handleChecked={(e: any) => {
          const value = e.target.value;
          creativeDispatch({
            type: "UPDATE_CREATIVE_METADATA_ICONS_COUNTDOWNICONPOSITION",
            payload: { countdownIconPosition: value },
          });
        }}
        values={["Left", "Right"]} />
    </div>
    <ComponentLibrary.PCSpacer type={"padding"} position={"bottom"} size={6} />
    <ComponentLibrary.PCSpacer type={"padding"} position={"top"} size={3} />
    <ComponentLibrary.PCDivider width={"w-100"} />
    <ComponentLibrary.PCSpacer type={"padding"} position={"top"} size={4} />
  </>;
}